import Vue from 'vue'
import VueRouter from 'vue-router'
import vLogin from '../components/vLogin.vue'
import vLogout from '../components/vLogout.vue'
import Map from '../components/GoogleMapLoader'


Vue.use(VueRouter)

const routes = [
    {path: '/', component: Map},
    {path: '/login', component: vLogin},
    {path: '/logout', component: vLogout},
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
